export const SPECIALISATION_FILTERS = [
  { key: 'all', label: 'All', apiValue: null },
  { key: 'first_home_buyers', label: 'First Home Buyers', apiValue: 'first_home_buyers' },
  { key: 'expats', label: 'Expats', apiValue: 'expats' },
  { key: 'small_business', label: 'Small Business', apiValue: 'small_business' },
  { key: 'retirement', label: 'Retirement', apiValue: 'retirement' },
  { key: 'debt_recovery', label: 'Debt Recovery', apiValue: 'debt_recovery' },
  { key: 'high_earners', label: 'High Earners', apiValue: 'high_earners' },
  { key: 'investing', label: 'Investing', apiValue: 'investing' },
  { key: 'tax_planning', label: 'Tax Planning', apiValue: 'tax_planning' },
];

export const SPECIALISATION_LABELS = Object.fromEntries(
  SPECIALISATION_FILTERS.filter((f) => f.key !== 'all').map((f) => [f.key, f.label]),
);

export const ADVISOR_ID_STORAGE_KEY = 'aura_advisor_id';

export function formatSpecialisation(key) {
  return SPECIALISATION_LABELS[key] || key.replace(/_/g, ' ');
}

export function truncateText(text, maxLen = 100) {
  const value = (text || '').trim();
  if (value.length <= maxLen) return value;
  return `${value.slice(0, maxLen - 3).trimEnd()}...`;
}

export function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  if (days === 1) return '1 day ago';
  if (days < 30) return `${days} days ago`;

  const months = Math.floor(days / 30);
  if (months === 1) return '1 month ago';
  return `${months} months ago`;
}

export function getStoredAdvisorId(user) {
  return user?.advisor_id || localStorage.getItem(ADVISOR_ID_STORAGE_KEY) || null;
}

export function setStoredAdvisorId(advisorId) {
  if (advisorId) {
    localStorage.setItem(ADVISOR_ID_STORAGE_KEY, advisorId);
  }
}

const followingStorageKey = (userId) => `aura_following_${userId}`;

export function getFollowingIds(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(followingStorageKey(userId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addFollowingId(userId, advisorId) {
  if (!userId || !advisorId) return;
  const ids = new Set(getFollowingIds(userId));
  ids.add(advisorId);
  localStorage.setItem(followingStorageKey(userId), JSON.stringify([...ids]));
}

export function isFollowingAdvisor(userId, advisorId) {
  return getFollowingIds(userId).includes(advisorId);
}
